<template>
  <v-container fluid>
    <CampaignDetails @onEdit="goToStep(0)" />
    <AdSetDetails @onEdit="goToStep(1)" />
    <AdDetails
      @exit-review="$emit('exit-review')"
      @go-to-step="$emit('go-to-step', $event)"
    />
    <div class="footer">
      <button class="btn back" @click="$emit('exit-review')">Back</button>
      <button class="btn publish" @click="handleCreateAd">Publish</button>
    </div>
    <!-- campain result -->
    <v-dialog v-model="resultDialog" max-width="700px" scrollable>
      <v-card>
        <v-card-title class="text-h6 mt-4"
          >Campaign Publishing Summary</v-card-title
        >

        <v-card-text style="max-height: 70vh; overflow-y: auto">
          <p>Your Super Ad campaign has been submitted.</p>
          <p class="mb-4">Here's the status of each platform:</p>

          <!-- ✅ Success -->
          <div
            v-for="(platform, name) in successPlatforms"
            :key="name"
            class="mb-4 pa-4 rounded"
            style="
              background-color: #e6f4ea;
              box-shadow: 0px 4px 8px rgba(102, 102, 102, 0.16);
            "
          >
            <!-- Title -->
            <div class="d-flex align-center mb-3">
              <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
              <span class="font-weight-bold text-success">Succeeded</span>
            </div>

            <!-- Platform Icon + Message -->
            <div
              class="d-flex align-center justify-start"
              style="gap: 6px; line-height: 1"
            >
              <img
                v-if="platform"
                :src="getPlatformIcon(name)"
                height="30"
                width="30"
                class="platform-icon"
                style="margin: 0; padding: 0"
              />
              <span style="font-size: 14px; line-height: 1; margin: 0">
                <strong>{{ name }}</strong> campaign was successfully published
              </span>
            </div>
          </div>

          <!-- ❌ Failed -->
          <div
            v-for="(error, name) in failedPlatforms"
            :key="name"
            class="mb-4 pa-4 rounded"
            style="
              background-color: #fdeaea;
              border: 1px solid #f5c2c7;
              box-shadow: 0px 4px 8px rgba(102, 102, 102, 0.16);
            "
          >
            <!-- Title -->
            <div class="d-flex align-center mb-3">
              <v-icon color="error" class="mr-2">mdi-close-circle</v-icon>
              <span class="font-weight-bold text-error">Failed</span>
            </div>

            <!-- Platform Icon + Message -->
            <div class="d-flex align-center" style="gap: 8px">
              <img
              v-if="platform"
                :src="getPlatformIcon(name)"
                height="30"
                width="30"
                class="platform-icon"
                style="margin: 0; padding: 0"
              />
              <p class="mb-0" style="font-size: 15px">
                <strong>{{ name }}</strong> Campaign failed to publish
              </p>
            </div>

            <!-- Reason -->
            <div class="mt-3 ml-1" style="font-size: 14px">
              <strong>Reason for Failure:</strong> {{ error }}
            </div>
          </div>
        </v-card-text>

        <v-card-actions style="margin-bottom: 1rem; margin-right: 1rem">
          <v-spacer />
          <v-btn class="btn back" @click="resultDialog = false">Cancel</v-btn>
          <v-btn class="btn publish" @click="resultDialog = false">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CampaignDetails from "./StepFour/CampaignDetails.vue";
import AdSetDetails from "./StepFour/AdSetDetails.vue";
import AdDetails from "./StepFour/AdDetails.vue";
import { useSuperAddStore } from "@/store/superAddStore";
import { useGeneralStore } from "@/store/General.js";

export default {
  name: "ReviewSummary",
  data() {
    return {
      store: useSuperAddStore(),
      errors: [],
      resultDialog: false,
      successPlatforms: {},
      failedPlatforms: {},
      upresult: false,
    };
  },
  components: {
    CampaignDetails,
    AdSetDetails,
    AdDetails,
  },
  methods: {
    goToStep(index) {
      this.$emit("go-to-step", index);
    },
    async handleCreateAd() {
      const generalStore = useGeneralStore();
      try {
        generalStore.ShowLoading();

        const result = await this.store.createSuperAd();

        this.successPlatforms = result.success;
        this.failedPlatforms = result.failed;
        this.resultDialog = true;
      } catch (error) {
        console.error("❌ Error in createSuperAd:", error);
        generalStore.showSnackbar("Failed to create ad", "error");
      } finally {
        generalStore.HideLoading();
      }
    },
    getPlatformIcon(name) {
      switch (name.toLowerCase()) {
        case "snapchat":
          return require("@/components/SuperApp/ReviewPageIcon/snap.svg");
        case "tiktok":
          return require("@/components/SuperApp/ReviewPageIcon/tiktok.svg");
        case "meta":
        case "facebook":
          return require("@/components/SuperApp/ReviewPageIcon/facebook.svg");
        default:
          return "";
      }
    },
  },
};
</script>
<style scoped>
.footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
  gap: 1rem;
}

.btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.btn.back {
  background-color: #f0f0f0;
  color: #333;
}

.btn.publish {
  background-color: #207878;
  color: #fff;
}
</style>
